import styled from 'styled-components';
import theme from 'styled-theming';

export const LayoutBg = theme('name', {
  light: 'rgba(28, 28, 28, 0.04)',
  dark: 'rgb(28, 28, 28)',
});

const LayoutContainer = styled.div`
  font-family: 'Shell Font';
  background-color: ${LayoutBg};
  min-height: 100vh;
  position: relative;
`;

const MidSection = styled.section`
  display: flex;
  flex: 0;
  min-height: calc(100vh - 76px);
  position: relative;
`;

const ContentContainer = styled.section`
  flex: 1;
  box-sizing: border-box;
  width: 100%;
  transition: margin-left 0.5s;
`;

export { LayoutContainer, MidSection, ContentContainer };
